import { render, staticRenderFns } from "./LaundryOrderManagement.vue?vue&type=template&id=063e8c96&scoped=true"
import script from "./LaundryOrderManagement.vue?vue&type=script&lang=js"
export * from "./LaundryOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./LaundryOrderManagement.vue?vue&type=style&index=0&id=063e8c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e8c96",
  null
  
)

export default component.exports